/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:40:54
 * @lastTime: 2023-11-10 15:52:32
 * @LastEditors: caiqin.xie
 * @message: 门店主页
 * @url: www.picoxr.com/cn/shop
 */
import React, {useState} from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Banner from "./components/Banner";
import ExperienceShop from "./components/ExpreienceShop";
import OfflineShop from "./components/OfflineShop";
import FindShop from "./components/FindShop";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST, SHOPPOS } from '@/common/const'
import styles from "./index.module.scss";

const Shop = (props: any) => {

  const {ctry, words, data} = props.data
  const {bannerList, experienceCenter, offlineStores, areas} = data
  const [nearShop, setNearShop] = useState<any>(data?.nearShop || null) // 附近的门店

  // 获取附近的门店
  const getList = (query:any) => {
    request.post(`${DOMAIN_API}/o/official/shop/list`, {
      manageType: '1',//管理类型 0-服务门店 1-零售门店
      rows:10,
      page:1,
      ...query,
      stationCode: ctry
    })
      .then(res => {
        setNearShop(res.data)
    })
    .catch(err => {
      console.log(err)
    })
  }
  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/shop`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{words?.shop_seo_title}</title>
        <meta name="description" content={words?.shop_seo_description} />
        <meta name="keywords" content={words?.shop_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/shop`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['shop-wrap']}>
        {/* banner区 */}
        <Banner words={words} bannerList={bannerList}/>
        {/* 体验店 */}
        <ExperienceShop ctry={ctry} words={words} experienceList={experienceCenter?.records} />
        {/* 内容区 */}
        <div className={styles["shop-content"]}>
          {/* 线下门店 */}
          <OfflineShop ctry={ctry} words={words} offlineList={offlineStores?.records} total={offlineStores.total * 1} />
          {/* 搜索门店 */}
          <FindShop ctry={ctry} words={words} nearShop={nearShop?.records[0]} areaList={areas} getList={(query) => getList(query)} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/official/shop/listGather`, {
      stationCode: ctry,
      bannerPositionId: SHOPPOS,
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

Shop.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default Shop;
